import { Injectable } from '@angular/core';
import { setSelectedProduct } from '@app/store/products/products.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { selectProfile } from '../patient-profile.selectors';
import { AppState } from '@app/store';
import { Store } from '@ngrx/store';
import { resetPatientProfileState } from '../patient-profile.actions';

@Injectable()
export class PatientProfileEffects {
  resetPatientProfileOnProductSelection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setSelectedProduct),
      withLatestFrom(this.store$.select(selectProfile)),
      filter(([{ selectedProduct }, patientProfile]) => selectedProduct?.product?.speciesCode !== patientProfile?.speciesCode),
      map(() => resetPatientProfileState()),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store<AppState>,
  ) {}
}
